// extracted by mini-css-extract-plugin
module.exports = {"text":"NetworkName_text__1He7N","warning":"NetworkName_warning__1ikRE"};